import { Popover } from "antd";
import React from "react";
import { MdPeople } from "react-icons/md";

function MinimumNumberOfParticipants({ minNumber }) {
  return (
    <Popover
      content={
        <div>
          Esta atividade apenas se realiza para um número de pessoas igual ou
          superior a {minNumber}.
        </div>
      }
      trigger="click"
    >
      <div
        style={{
          marginLeft: 50,
          marginBottom: 10,
          textAlign: "center",
          width: 50,
          border: "4px solid grey",
          borderRadius: "50%",
        }}
      >
        <MdPeople style={{ margin: "0 auto" }} size={20} />
        <div style={{ marginTop: -12 }}>{minNumber}+</div>
      </div>
    </Popover>
  );
}

export default MinimumNumberOfParticipants;
